<div
  class="page-cover"
  [style.background]="bgImage"
  [style.backgroundSize]="'cover'"
></div>
<div class="page-filter" [style.opacity]="bgFilterOpacity"></div>
<div class="content" [class.mat-elevation-z8]="true">
  <mat-card style="height: 400px">
    <mat-card-content>
      <div
        fxLayout="column"
        fxLayoutAlign="start center"
        class="accent-text-color"
      >
        <div
          style="
            font-size: 26px;
            text-align: center;
            margin-top: 20px;
            margin-bottom: 50px;
          "
        >
          {{ 'l10n_sessionExpired' | translate }}
        </div>
        <mat-icon fxFlex="none" style="font-size: 200px; margin-left: -200px"
          >web</mat-icon
        >
        <mat-icon
          fxFlex="none"
          style="font-size: 80px; margin-left: 160px; margin-top: -50px"
          >history</mat-icon
        >
        <div
          fxFlex="none"
          fxLayout="row"
          fxLayoutAlign="start center"
          style="margin-top: 220px; width: 100%"
        >
          <button mat-flat-button color="primary" (click)="onTryAgain()">
            {{ 'l10n_tryAgain' | translate }}
          </button>
          <div fxFlex="auto"></div>
          <button mat-stroked-button color="primary" (click)="onLogin()">
            {{ 'key_logout' | translate }}
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
